import { constants as appConstants } from 'app/client/store/reducers/app';

const mapStateToProps = ({ app: { newVersion, error } }) => ({
  newVersion,
  error,
});

const mapDispatchToProps = (dispatch) => ({
  clearError: () => dispatch({ type: appConstants.setError, payload: null }),
});

export default [mapStateToProps, mapDispatchToProps];
